import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Company} from 'classes/company';
import {User} from 'classes/user';
import {UserRole} from 'classes/user-role';
import {UserDetailsRepository} from '../repositories/user-details.repository';
import { Content } from 'shared/models/contents/content';
import { Badge } from 'shared/models/badges/badge';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Category } from 'shared/models/target-groups/category';
import { Group } from 'shared/models/target-groups/group';

@Injectable()
export class UserDetailsService {

  constructor(private userDetailsRepository: UserDetailsRepository) { }

  public getUser(id: number): Observable<User> {
    return this.userDetailsRepository.getUser(id);
  }

  public getAllCompanies(): Observable<Array<Company>> {
    return this.userDetailsRepository.getAllCompanies();
  }

  public getAllContents(): Observable<Array<Content>> {
    return this.userDetailsRepository.getAllContents();
  }

  public getAllBadges(): Observable<Array<Badge>> {
    return this.userDetailsRepository.getAllBadges();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.userDetailsRepository.getAllTargetGroups();
  }

  public getAllGroups(): Observable<Array<Group>> {
    return this.userDetailsRepository.getAllGroups();
  }

  public getAllCategories(): Observable<Array<Category>> {
    return this.userDetailsRepository.getAllCategories();
  }

  public saveUser(user: User, userRoles: Array<any>): Observable<User> { // tslint:disable-line:no-any
    this.insertRolesIntoUser(user, userRoles);
    return this.userDetailsRepository.saveUser(user);
  }

  public updateUser(user: User, userRoles: Array<any>): Observable<User> { // tslint:disable-line:no-any
    this.insertRolesIntoUser(user, userRoles);
    return this.userDetailsRepository.updateUser(user);
  }

  public getUserRoles(): Observable<Array<UserRole>> {
    return this.userDetailsRepository.getUserRoles();
  }

  private insertRolesIntoUser(user: User, userRoles: Array<any>): void { // tslint:disable-line:no-any

    user.roles = userRoles.filter((userRole) => {
      return userRole.checked;
    });
  }

  public deleteUnstartedContents(user: User): Observable<boolean> {
    return this.userDetailsRepository.deleteUnstartedContents(user);
  }

  public modifyContents(user: User, modContent: Array<any>): Observable<boolean> {
    return this.userDetailsRepository.modifyContents(user, modContent);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-details/services/user-details.service.ts